export default __webpack_public_path__ + "static/custom-logo-1-45ba4b2f09393d0326a96c21e4d8d89e.webp";